<template>
  <div class="account-page" :class="{ 'salt-account-page': isSalt }">
    <header v-if="!embedded"><h1>账号与登录</h1></header>
    <div class="account-connections-grid">
      <SiteAccountPanel />
      <SaltCard v-if="isSalt" header="WebDAV 连接" inset class="account-dav-card"><WebDavConnections /></SaltCard>
      <WebDavConnections v-else />
    </div>
    <div class="account-platform-grid" aria-label="平台账号">
      <AccountPanel v-for="platform in ['qq', 'netease']" :key="platform" :fixed-platform="platform" />
    </div>
  </div>
</template>
<script>
import AccountPanel from '../components/AccountPanel.vue';
import SiteAccountPanel from '../components/SiteAccountPanel.vue';
import WebDavConnections from '../components/WebDavConnections.vue';
import SaltCard from '../salt/ui/SaltCard.vue';
import { workspace } from '../workspace';
export default { name: 'Account', components: { AccountPanel, SiteAccountPanel, WebDavConnections, SaltCard }, props: { embedded: Boolean }, data() { return { workspace }; }, computed: { isSalt() { return this.workspace.appearance === 'salt'; } } };
</script>
<style scoped>
.account-page { max-width:1000px;margin:auto; }.account-page h1 { margin:32px 0 12px;font-size:36px; }
.salt-account-page { width:100%;max-width:none;min-width:0;color:var(--salt-text);font-size:var(--salt-text-main,14px); }
.salt-account-page > header { display:flex;align-items:center;min-height:56px; }
.salt-account-page > header h1 { margin:0;font-size:var(--salt-text-title,24px);font-weight:500; }
.account-page { container-type:inline-size; }
.account-connections-grid,.account-platform-grid { display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px;align-items:start; }
.account-platform-grid { margin-top:8px; }
.account-connections-grid > *,.account-platform-grid > * { min-width:0; }
.account-dav-card ::v-deep(.salt-ui-card) { width:100%;margin:8px 0; }
.account-dav-card ::v-deep(.section-heading) { padding:10px 16px 6px; }
.account-dav-card ::v-deep(.webdav-manager) { min-width:0;padding:0 16px; }
.account-dav-card ::v-deep(h3),.account-dav-card ::v-deep(.salt-dav-heading > .item-copy) { display:none; }
.account-dav-card ::v-deep(.salt-dav-heading > .trailing) { margin:0;max-width:none; }
.account-dav-card ::v-deep(.saved-connection) { flex-wrap:wrap; }
.account-dav-card ::v-deep(.saved-connection > .trailing) { flex:1 0 100%;margin:0; }
.account-dav-card ::v-deep(.source-actions) { justify-content:flex-start;max-width:100%; }
.account-dav-card ::v-deep(.credential-replace) { flex-wrap:nowrap; }
.account-dav-card ::v-deep(.credential-replace > .item-copy) { flex:1; }
.account-dav-card ::v-deep(.credential-replace > .trailing) { flex:0 0 46px;margin:0; }
.account-dav-card ::v-deep(.dav-editor) { margin:8px 0 16px;padding:12px; }
.account-dav-card ::v-deep(.dav-help summary) { color:var(--salt-subtext);font-size:12px; }
@container(max-width:760px){.account-connections-grid,.account-platform-grid{grid-template-columns:minmax(0,1fr);gap:10px;}}
#app.salt-mobile-layout .account-connections-grid,#app.salt-mobile-layout .account-platform-grid { grid-template-columns:minmax(0,1fr);gap:10px; }
@media(max-width:600px){.account-page:not(.salt-account-page) h1{font-size:28px;margin-top:20px;}}
</style>
